import classNames from 'classnames'

import google from 'assets/img/common/google.png'

import styles from './styles.module.scss'
import { ProfessorsV2 } from './ProfessorsV2'

export const Professors = props => {
  const { data, addGoogleCard, googleCardText, addAdditionalPartners, newLayout } = props


  return (
    <div className={styles.professors}>
      <div className={newLayout ? "container-fluid" : "container"}>
        <h4 className={styles.title}>{data?.title}</h4>

        {newLayout ? <ProfessorsV2 data={data} /> :

          <div className={styles.tabs}>
            <div
              className={classNames(styles.tabPills, 'nav')}
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              {data?.professors?.map((item, idx) => (
                <>
                  <button
                    className={classNames(styles.pill, idx === 0 ? 'active' : '')}
                    id={`v-pills-${item?.id}-tab`}
                    data-toggle="pill"
                    data-target={`#v-pills-${item?.id}`}
                    type="button"
                    role="tab"
                    aria-controls={`v-pills-${item?.id}`}
                    aria-selected={idx === 0 ? 'true' : 'false'}
                  >
                    <span className={styles.tabTitle}>
                      <img
                        src={item?.img?.src}
                        alt={item?.img?.alt}
                        className={styles.avatar}
                      />
                      <span className={styles.name}>{item?.name}</span>
                    </span>
                  </button>
                  {idx === 0 ? (
                    <p className="mt-10 mb-0">
                      Some mentors from previous programs
                    </p>
                  ) : null}
                </>
              ))}
            </div>
            <div
              className={classNames(styles.tabContent, 'tab-content')}
              id="v-pills-tabContent"
            >
              {data?.professors?.map((item, idx) => (
                <div
                  className={classNames(
                    'tab-pane fade',
                    idx === 0 ? 'show active' : ''
                  )}
                  id={`v-pills-${item?.id}`}
                  role="tabpanel"
                  aria-labelledby={`v-pills-${item?.id}-tab`}
                >
                  <div className={styles.tabPane}>
                    <div className={styles.top}>
                      {item?.svg ? (
                        item?.svg
                      ) : (
                        <div className="img-highlighted left">
                          <img
                            src={item?.img?.src}
                            alt={item?.img?.alt}
                            className={styles.avatar}
                          />
                        </div>
                      )}
                      {item?.id === 'columbia-university' ? null : (
                        <h5 className={styles.name}>{item?.name}</h5>
                      )}
                    </div>
                    <div className={styles.desc}>{item?.desc}</div>
                  </div>
                  {addGoogleCard ? (
                    <div className={classNames(styles.tabPane, 'mt-20')}>
                      <div className={styles.top}>
                        <img
                          src={google}
                          alt="Google"
                          className={styles.avatar}
                        />
                        <h5 className={styles.name}>
                          Google Industry Professionals
                        </h5>
                      </div>
                      <div className={styles.desc}>
                        <p>{googleCardText}</p>
                      </div>
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        }
      </div>
    </div>
  )
}
